import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx } from "vue";
import { UIContentWrap } from '@gohighlevel/ghl-ui';
import '@gohighlevel/ghl-ui/dist/style.css';
import { setupGlobalEmitter } from 'src/plugin/global-emitter';
import { setupPinia } from 'src/plugin/pinia';
import { setupVueI18n } from 'src/plugin/vue-i18n';
import { computed, provide, ref } from 'vue';
import useEmitter from '../composable/useEmitter';
import '../index.css';
import { useStore } from '../store';
import MediaModalView from './MediaModalView.vue';
import MediaModalUsageView from './MediaModalUsageView.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaContainerModal',
    props: {
        route: {},
        router: {},
        emitter: {},
        store: {},
        locale: {},
        settings: {}
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f;
        const props = __props;
        // inject current route
        provide('route', props.route);
        provide('router', props.router);
        provide('emitter', props.emitter);
        provide('store', props.store);
        setupVueI18n(props.locale, true);
        setupPinia(true);
        setupGlobalEmitter(true);
        const state = useStore();
        const emitter = useEmitter();
        const showModal = ref(false);
        const showUsageModal = ref(false);
        const sudoSetting = ref({});
        const calledModal = ref(false);
        const fromSpmts = computed(() => props.route.name === 'media-settings-v2');
        (_a = props.emitter) === null || _a === void 0 ? void 0 : _a.on('media-library-open', (payload) => {
            var _a, _b, _c, _d, _e, _f;
            showModal.value = true;
            sudoSetting.value = payload;
            state.directoryRoute = [];
            state.mediaModal = true;
            state.userRole = (_c = (_b = (_a = props.store) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.user.role;
            state.companyId = props.settings.companyId;
            state.userId = (_f = (_e = (_d = props.store) === null || _d === void 0 ? void 0 : _d.state) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f.user.id;
            state.updateMetaInfo(payload);
        });
        (_b = props.emitter) === null || _b === void 0 ? void 0 : _b.on('media-usage-model-open', () => {
            if (showModal.value) {
                showModal.value = false;
            }
            showUsageModal.value = true;
        });
        (_c = props.emitter) === null || _c === void 0 ? void 0 : _c.on('closeMediaModal', value => {
            if (value && showModal.value) {
                calledModal.value = true;
            }
            else {
                sudoSetting.value = {};
            }
            state.uploadQueue = [];
            showModal.value = false;
            state.mediaModal = false;
        });
        (_d = props.emitter) === null || _d === void 0 ? void 0 : _d.on('closeMediaUsageModal', () => {
            showUsageModal.value = false;
            if (props.route.name !== 'media-settings-v2') {
                showModal.value = true;
            }
        });
        (_e = props.emitter) === null || _e === void 0 ? void 0 : _e.on('content-ai-generated-image', () => {
            if (calledModal.value) {
                showModal.value = true;
                emitter.emit('updateParent');
                calledModal.value = false;
                state.mediaModal = true;
            }
        });
        (_f = props.emitter) === null || _f === void 0 ? void 0 : _f.on('content-ai--close_modal', () => {
            if (calledModal.value) {
                showModal.value = true;
                emitter.emit('updateUI');
                calledModal.value = false;
                state.mediaModal = true;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIContentWrap), { fullScreen: true }, {
                default: _withCtx(() => [
                    (showModal.value)
                        ? (_openBlock(), _createBlock(MediaModalView, {
                            key: 0,
                            settings: showModal.value ? sudoSetting.value : _ctx.settings,
                            showModal: showModal.value,
                            fromSpmts: fromSpmts.value,
                            onClose: _cache[0] || (_cache[0] = ($event) => (showModal.value = false))
                        }, null, 8 /* PROPS */, ["settings", "showModal", "fromSpmts"]))
                        : _createCommentVNode("v-if", true),
                    (showUsageModal.value)
                        ? (_openBlock(), _createBlock(MediaModalUsageView, {
                            key: 1,
                            settings: _ctx.settings,
                            showModal: showUsageModal.value,
                            onClose: _cache[1] || (_cache[1] = ($event) => (showUsageModal.value = false))
                        }, null, 8 /* PROPS */, ["settings", "showModal"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
